import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-105e5129")
const _hoisted_1 = { class: "navigation-container position-relative" }
const _hoisted_2 = {
  key: 0,
  class: "logo-akko hide-small",
  src: "/icons/logo.svg",
  alt: "Akko logo"
}
const _hoisted_3 = {
  key: 1,
  class: "mb-4 mt-5 text-muted navigation-section"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  primary: "",
  class: "\n            px-25\n            py-1\n            btn btn-primary\n            inter\n            btn-mobile btn-compact\n            w-100-mobile\n            fw-600\n            ml-auto\n            d-flex\n            align-items-center\n            fs-65\n          "
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-5 align-plus me-2" }, "+"),
  /*#__PURE__*/_createTextVNode(" Add New Plan ")
], -1)
const _hoisted_5 = { class: "nav nav-pills flex-column text-start w-100-l" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Dashboard ")
const _hoisted_8 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Sales Report ")
const _hoisted_10 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Claims ")
const _hoisted_12 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Team ")
const _hoisted_14 = {
  key: 3,
  class: "nav-item"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Customers ")
const _hoisted_16 = {
  key: 4,
  class: "nav-item"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Properties ")
const _hoisted_18 = {
  key: 5,
  class: "nav-item"
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Marketing ")
const _hoisted_20 = {
  key: 6,
  class: "nav-item"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Settings ")
const _hoisted_22 = {
  key: 4,
  class: "mt-5 mb-4 text-muted navigation-section"
}
const _hoisted_23 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_24 = {
  class: "nav-link",
  href: "https://akko.link/partner-platform-training",
  target: "_blank"
}
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Training ")
const _hoisted_26 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_27 = {
  class: "nav-link",
  href: "https://akko.link/partner-platform-faq-info",
  target: "_blank"
}
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" FAQs & Info ")
const _hoisted_29 = { class: "nav-item" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Contact us ")
const _hoisted_31 = {
  key: 1,
  class: "nav-link",
  href: "mailto:support@avteka.com"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_GridIcon = _resolveComponent("GridIcon")!
  const _component_SalesIcon = _resolveComponent("SalesIcon")!
  const _component_ClaimsIcon = _resolveComponent("ClaimsIcon")!
  const _component_PeopleIcon = _resolveComponent("PeopleIcon")!
  const _component_UsersIcon = _resolveComponent("UsersIcon")!
  const _component_HomeIcon = _resolveComponent("HomeIcon")!
  const _component_MarketingIcon = _resolveComponent("MarketingIcon")!
  const _component_SettingsIcon = _resolveComponent("SettingsIcon")!
  const _component_YoutubeIcon = _resolveComponent("YoutubeIcon")!
  const _component_FaqIcon = _resolveComponent("FaqIcon")!
  const _component_MessageIcon = _resolveComponent("MessageIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.partnerProgram === _ctx.PartnerPrograms.AKKO)
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.partnerProgram !== _ctx.PartnerPrograms.AKKO)
      ? (_openBlock(), _createElementBlock("h5", _hoisted_3, " Quick Actions "))
      : _createCommentVNode("", true),
    (
        _ctx.hasPartnerRegisterNewPlanViewTabPermission &&
        _ctx.hasPartnerPortalRegisterNewPlanViewTabPermission
      )
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["nav-pills", { 'mb-4': _ctx.partnerProgram === _ctx.PartnerPrograms.AKKO }])
        }, [
          _createVNode(_component_router_link, {
            to: _ctx.RoutePath.HOME_REGISTER_NEW_PLAN,
            class: _normalizeClass(["nav-link", {
          active: _ctx.isActive([_ctx.RouteNames.HOME_REGISTER_NEW_PLAN]),
        }])
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["to", "class"])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.partnerProgram !== _ctx.PartnerPrograms.AKKO)
      ? (_openBlock(), _createElementBlock("h5", {
          key: 3,
          class: _normalizeClass(["mt-5 mb-4 text-muted navigation-section", { 'mt-5': _ctx.partnerProgram !== _ctx.PartnerPrograms.AKKO }])
        }, " MAIN ", 2))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_5, [
      _createElementVNode("li", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: "/",
          class: _normalizeClass(["nav-link", {
            active: _ctx.isActive([_ctx.RouteNames.HOME_MENU]),
          }])
        }, {
          default: _withCtx(() => [
            (_ctx.partnerProgram === _ctx.PartnerPrograms.AKKO)
              ? (_openBlock(), _createBlock(_component_GridIcon, { key: 0 }))
              : _createCommentVNode("", true),
            _hoisted_7
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      (
          _ctx.accessSales &&
          _ctx.hasPartnerSalesReportViewTabPermission &&
          _ctx.hasPartnerPortalSalesReportViewTabPermission
        )
        ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
            _createVNode(_component_router_link, {
              to: _ctx.RoutePath.HOME_SALES_REPORT,
              class: _normalizeClass(["nav-link", {
            active:
              _ctx.isActive(_ctx.RouteNames.HOME_SALES_REPORT) ||
              _ctx.isActive(_ctx.RouteNames.HOME_SALES_TEAM),
          }])
            }, {
              default: _withCtx(() => [
                (_ctx.partnerProgram === _ctx.PartnerPrograms.AKKO)
                  ? (_openBlock(), _createBlock(_component_SalesIcon, { key: 0 }))
                  : _createCommentVNode("", true),
                _hoisted_9
              ]),
              _: 1
            }, 8, ["to", "class"])
          ]))
        : _createCommentVNode("", true),
      (
          _ctx.partnerProgram === _ctx.PartnerPrograms.AKKO &&
          _ctx.hasPartnerClaimsViewTabPermission &&
          _ctx.hasPartnerPortalClaimsViewTabPermission
        )
        ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: _ctx.RoutePath.HOME_CLAIMS,
              class: _normalizeClass(["nav-link", { active: _ctx.isActive(_ctx.RouteNames.HOME_CLAIMS) }])
            }, {
              default: _withCtx(() => [
                (_ctx.partnerProgram === _ctx.PartnerPrograms.AKKO)
                  ? (_openBlock(), _createBlock(_component_ClaimsIcon, { key: 0 }))
                  : _createCommentVNode("", true),
                _hoisted_11
              ]),
              _: 1
            }, 8, ["to", "class"])
          ]))
        : _createCommentVNode("", true),
      (
          _ctx.accessTeams &&
          _ctx.hasPartnerTeamViewTabPermission &&
          _ctx.hasPartnerPortalTeamViewTabPermission
        )
        ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
            _createVNode(_component_router_link, {
              to: _ctx.RoutePath.HOME_REPRESENTATIVES,
              class: _normalizeClass(["nav-link", { active: _ctx.isActive(_ctx.RouteNames.HOME_REPRESENTATIVES) }])
            }, {
              default: _withCtx(() => [
                (_ctx.partnerProgram === _ctx.PartnerPrograms.AKKO)
                  ? (_openBlock(), _createBlock(_component_PeopleIcon, { key: 0 }))
                  : _createCommentVNode("", true),
                _hoisted_13
              ]),
              _: 1
            }, 8, ["to", "class"])
          ]))
        : _createCommentVNode("", true),
      (
          _ctx.accessEndUsers &&
          _ctx.hasPartnerCustomersViewTabPermission &&
          _ctx.hasPartnerPortalCustomersViewTabPermission
        )
        ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
            _createVNode(_component_router_link, {
              to: _ctx.RoutePath.HOME_END_USERS,
              class: _normalizeClass(["nav-link", { active: _ctx.isActive(_ctx.RouteNames.HOME_END_USERS) }])
            }, {
              default: _withCtx(() => [
                (_ctx.partnerProgram === _ctx.PartnerPrograms.AKKO)
                  ? (_openBlock(), _createBlock(_component_UsersIcon, { key: 0 }))
                  : _createCommentVNode("", true),
                _hoisted_15
              ]),
              _: 1
            }, 8, ["to", "class"])
          ]))
        : _createCommentVNode("", true),
      (
          _ctx.accessProperties &&
          _ctx.hasPartnerPropertiesViewTabPermission &&
          _ctx.hasPartnerPortalPropertiesViewTabPermission
        )
        ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
            _createVNode(_component_router_link, {
              to: _ctx.RoutePath.HOME_PROPERTIES,
              class: _normalizeClass(["nav-link", { active: _ctx.isActive(_ctx.RouteNames.HOME_PROPERTIES) }])
            }, {
              default: _withCtx(() => [
                (_ctx.partnerProgram === _ctx.PartnerPrograms.AKKO)
                  ? (_openBlock(), _createBlock(_component_HomeIcon, { key: 0 }))
                  : _createCommentVNode("", true),
                _hoisted_17
              ]),
              _: 1
            }, 8, ["to", "class"])
          ]))
        : _createCommentVNode("", true),
      (
          _ctx.partnerProgram === _ctx.PartnerPrograms.AKKO &&
          _ctx.hasPartnerMarketingMaterialsViewTabPermission &&
          _ctx.hasPartnerPortalMarketingMaterialsViewTabPermission
        )
        ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
            _createVNode(_component_router_link, {
              to: _ctx.RoutePath.HOME_MARKETING_MATERIALS,
              class: _normalizeClass(["nav-link", { active: _ctx.isActive(_ctx.RouteNames.HOME_MARKETING_MATERIALS) }])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_MarketingIcon),
                _hoisted_19
              ]),
              _: 1
            }, 8, ["to", "class"])
          ]))
        : _createCommentVNode("", true),
      (
          _ctx.hasPartnerSettingsViewTabPermission &&
          _ctx.hasPartnerPortalSettingsViewTabPermission
        )
        ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
            _createVNode(_component_router_link, {
              to: _ctx.RoutePath.HOME_ACCOUNT,
              class: _normalizeClass(["nav-link", { active: _ctx.isActive(_ctx.RouteNames.HOME_ACCOUNT) }])
            }, {
              default: _withCtx(() => [
                (_ctx.partnerProgram === _ctx.PartnerPrograms.AKKO)
                  ? (_openBlock(), _createBlock(_component_SettingsIcon, { key: 0 }))
                  : _createCommentVNode("", true),
                _hoisted_21
              ]),
              _: 1
            }, 8, ["to", "class"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.partnerProgram !== _ctx.PartnerPrograms.AKKO)
      ? (_openBlock(), _createElementBlock("h5", _hoisted_22, " SUPPORT "))
      : _createCommentVNode("", true),
    _createElementVNode("ul", {
      class: _normalizeClass(["nav nav-pills flex-column text-start", { 'mt-5': _ctx.partnerProgram === _ctx.PartnerPrograms.AKKO }])
    }, [
      (
          _ctx.partnerProgram === _ctx.PartnerPrograms.AKKO &&
          _ctx.hasPartnerTrainingViewTabPermission &&
          _ctx.hasPartnerPortalTrainingViewTabPermission
        )
        ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
            _createElementVNode("a", _hoisted_24, [
              (_ctx.partnerProgram === _ctx.PartnerPrograms.AKKO)
                ? (_openBlock(), _createBlock(_component_YoutubeIcon, { key: 0 }))
                : _createCommentVNode("", true),
              _hoisted_25
            ])
          ]))
        : _createCommentVNode("", true),
      (
          _ctx.partnerProgram === _ctx.PartnerPrograms.AKKO &&
          _ctx.hasPartnerFaqsInfoViewTabPermission &&
          _ctx.hasPartnerPortalFaqsInfoViewTabPermission
        )
        ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
            _createElementVNode("a", _hoisted_27, [
              _createVNode(_component_FaqIcon),
              _hoisted_28
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", _hoisted_29, [
        (!_ctx.isInjuredGadgets)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "nav-link",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showChat && _ctx.showChat(...args)))
            }, [
              (_ctx.partnerProgram === _ctx.PartnerPrograms.AKKO)
                ? (_openBlock(), _createBlock(_component_MessageIcon, { key: 0 }))
                : _createCommentVNode("", true),
              _hoisted_30
            ]))
          : (_openBlock(), _createElementBlock("a", _hoisted_31, " Contact us "))
      ])
    ], 2)
  ]))
}